// extracted by mini-css-extract-plugin
export default {"risk":"style_risk__bJfZH","risk__button":"style_risk__button__Z8Llf","risk__button_active":"style_risk__button_active__DwBNU"};